import React, { useContext, useEffect, useState } from 'react';
import { Label } from '@americanexpress/dls-react';
import { Select, Alert, SelectOption, Input, Heading } from '@americanexpress/dls-react';
import UserContext from '../ContextComponent/UserContext';
import { CONSTANTS } from '../../constants';
function Ckyc() {
    const [displayNameField, setDisplayNameField] = useState("hidden");
    const [relation, setRelation] = useState('');
    const [FirstNameId, setFirstNameId] = useState("");
    const [MiddleNameId, setMiddleNameId] = useState("");
    const [LastNameId, setLastNameId] = useState("");
    const [isLoad, setIsLoad] = useState(true);
    const { formData, setFormData } = useContext(UserContext);
    const { errorData, setErrorData } = useContext(UserContext);
    const [titleArray, setTitleArray] = useState([]);
    const fatherFrstName = 'FatherFirstName';
    const motherFrstName = 'MotherFirstName';
    const fatherMdlName = 'FatherMiddleName';
    const motherMdlName = 'MotherMiddleName';
    const fatherLstName = 'FatherLastName';
    const motherLstName = 'MotherLastName';
    const spouseFrstName = 'SpouseFirstName';
    const spouseMdlName = 'SpouseMiddleName';
    const spouseLstName = 'SpouseLastName';
    const father = 'father';
    const mother = 'mother';
    const spouse = 'spouse';
    const fatherTitle = [
        {
            name: 'Mr / Shri',
            value: 'MR'
        },
        {
            name: 'Mx',
            value: 'MX'
        }];
    const motherTitle = [
        {
            name: 'Ms',
            value: 'MS'
        },
        {
            name: 'Mrs / Smt',
            value: 'MRS'
        }];
    const spouseTitle = [
        {
            name: 'Mr / Shri',
            value: 'MR'
        },
        {
            name: 'Mx',
            value: 'MX'
        }];


    useEffect(() => {
        fnBindData();
        setIsLoad(false);
    }, []);

    useEffect(() => {
        fnBindData();
    }, [formData.haveForm60, formData.panNumber, formData.title])

    useEffect(() => {
        setFormData({ ...formData, fatherOrMotherNameIsProvided: relation });
        if (relation !== "") {
            setDisplayNameField("");
            setErrorData({ ...errorData, fatherOrMotherNameRequired: false });
            if (relation === father) {
                setFirstNameId(fatherFrstName);
                setMiddleNameId(fatherMdlName);
                setLastNameId(fatherLstName);
                selectTitle(father);
            }
            else if (relation === spouse) {
                setFirstNameId(spouseFrstName);
                setMiddleNameId(spouseMdlName);
                setLastNameId(spouseLstName);
                selectTitle(spouse);
            }
            else if (relation === mother) {
                setFirstNameId(motherFrstName);
                setMiddleNameId(motherMdlName);
                setLastNameId(motherLstName);
                selectTitle(mother);
            }
            else {
                setRelation('');
            }
        }
        else {
            setDisplayNameField("hidden");
            if (!isLoad)
                setErrorData({ ...errorData, fatherOrMotherNameRequired: true });
        }
    }, [relation]);

    const fnBindData = () => {
        if (formData.haveForm60)
            setRelation(father);
        else if (formData.haveForm60 === false && formData.title === 'MRS')
            setRelation(spouse);
        else
            setRelation('');
    }

    const onRelationChange = (event) => {
        setRelation(event.target.value);
    }

    const onTitleChange = (event) => {
        if (event.target.value === '') {
            setErrorData({ ...errorData, fatherOrMotherTitleRequired: true });
        }
        else {
            setFormData({ ...formData, fatherOrMotherTitle: event.target.value });
            setErrorData({ ...errorData, fatherOrMotherTitleRequired: false });
        }
    };
    const onFNameBlur = (event) => {
        var newVal = event.target.value.replace(/ +(?= )/g, '').trim();
        setFormData({ ...formData, fatherOrMotherFName: newVal });
        event.target.value = newVal;

        if (event.target.value !== '') {
            const result = !CONSTANTS.validation.namePattern.test(event.target.value);
            setErrorData({ ...errorData, fatherOrMotherFNameAlphaNumeric: result, fatherOrMotherFNameRequired: false });
            if (event.target.name === fatherFrstName) {
                setFormData({ ...formData, fatherFirstName: event.target.value });
            }
            else if (event.target.name === spouseFrstName) {
                setFormData({ ...formData, spouseFirstName: event.target.value });
            }
            else {
                setFormData({ ...formData, motherFirstName: event.target.value });
            }
        }
        else {
            setErrorData({ ...errorData, fatherOrMotherFNameRequired: true, fatherOrMotherFNameAlphaNumeric: false });
            if (event.target.name === fatherFrstName) {
                setFormData({ ...formData, fatherFirstName: event.target.value });
            }
            else if (event.target.name === spouseFrstName) {
                setFormData({ ...formData, spouseFirstName: event.target.value });
            }
            else {
                setFormData({ ...formData, motherFirstName: event.target.value });
            }
        }
    };
    const onMNameBlur = (event) => {
        var newVal = event.target.value.replace(/ +(?= )/g, '').trim();
        setFormData({ ...formData, fatherOrMotherMName: newVal });
        event.target.value = newVal;

        if (event.target.value !== '') {
            const result = !CONSTANTS.validation.namePattern.test(event.target.value);
            setErrorData({ ...errorData, fatherOrMotherMNameAlphaNumeric: result });
            if (event.target.name === fatherMdlName) {
                setFormData({ ...formData, fatherMiddleName: event.target.value });
            }
            else if (event.target.name === spouseMdlName) {
                setFormData({ ...formData, spouseMiddleName: event.target.value });
            }
            else {
                setFormData({ ...formData, motherMiddleName: event.target.value });
            }
        }
        else {
            setErrorData({ ...errorData, fatherOrMotherMNameAlphaNumeric: false });
            if (event.target.name === fatherMdlName) {
                setFormData({ ...formData, fatherMiddleName: event.target.value });
            }
            else if (event.target.name === spouseMdlName) {
                setFormData({ ...formData, spouseMiddleName: event.target.value });
            }
            else {
                setFormData({ ...formData, motherMiddleName: event.target.value });
            }
        }
    };
    const onLNameBlur = (event) => {
        var newVal = event.target.value.replace(/ +(?= )/g, '').trim();
        setFormData({ ...formData, fatherOrMotherLName: newVal });
        event.target.value = newVal;

        if (event.target.value !== '') {
            const result = !CONSTANTS.validation.namePattern.test(event.target.value);
            setErrorData({ ...errorData, fatherOrMotherLNameAlphaNumeric: result, fatherOrMotherLNameRequired: false });
            if (event.target.name === fatherLstName) {
                setFormData({ ...formData, fatherLastName: event.target.value });
            }
            else if (event.target.name === spouseLstName) {
                setFormData({ ...formData, spouseLastName: event.target.value });
            }
            else {
                setFormData({ ...formData, motherLastName: event.target.value });
            }
        }
        else {
            setErrorData({ ...errorData, fatherOrMotherLNameRequired: true, fatherOrMotherLNameAlphaNumeric: false });
            if (event.target.name === fatherLstName) {
                setFormData({ ...formData, fatherLastName: event.target.value });
            }
            else if (event.target.name === spouseLstName) {
                setFormData({ ...formData, spouseLastName: event.target.value });
            }
            else {
                setFormData({ ...formData, motherLastName: event.target.value });
            }
        }
    };
    const onCkycBlur = (event) => {
        setFormData({ ...formData, ckycNo: event.target.value });

        if (event.target.value !== '') {
            const result = !CONSTANTS.validation.ckycPattern.test(event.target.value);
            setErrorData({ ...errorData, ckycAlphaNumericRequired: result });
        }
        else {
            setErrorData({ ...errorData, ckycAlphaNumericRequired: false });
        }
    };
    const selectTitle = (title) => {
        setTitleArray([]);
        if (title === father) {
            setTitleArray(fatherTitle);
        }
        else if (title === mother) {
            setTitleArray(motherTitle)
        }
        else if (title === spouse) {
            setTitleArray(spouseTitle)
        }
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength);
        }
    }

    return (
        <div className="stack">
            <Heading level={2} headingStyle="heading4"> Additional Personal Details</Heading>
            <div className="row">
                <div className="col-md-6">
                    {formData.haveForm60 &&
                        <Label htmlFor="Relation" className="label-1">Please share your Father's Name</Label>
                    }
                    {formData.haveForm60 === false && (formData.title === 'MR' || formData.title === 'MS' || formData.title === 'MISS' || formData.title === 'MX') &&
                        <Label htmlFor="Relation" className="label-1">Please share your Father's or Mother's Name</Label>
                    }
                    {formData.haveForm60 === false && formData.title === 'MRS' &&
                        <Label htmlFor="Relation" className="label-1">Please share your Spouse's Name</Label>
                    }
                    <Select
                        id="Relation"
                        name="Relation"
                        className="fluid"
                        required={true}
                        onChange={onRelationChange} >
                        {formData.haveForm60 &&
                            <SelectOption value="father">Father's Name</SelectOption>
                        }
                        {formData.haveForm60 === false && (formData.title === 'MR' || formData.title === 'MS' || formData.title === 'MISS' || formData.title === 'MX') &&
                            <>
                                <SelectOption value="">Select</SelectOption>
                                <SelectOption value="father">Father's Name</SelectOption>
                                <SelectOption value="mother">Mother's Name</SelectOption>
                            </>
                        }
                        {formData.haveForm60 === false && formData.title === 'MRS' &&
                            <SelectOption value="spouse">Spouse's Name</SelectOption>
                        }
                    </Select>
                </div>
                <div className="col-md-6" />
                <Alert id="FatherOrMotherName-Alert" show={errorData.fatherOrMotherNameRequired}>Please make a selection.</Alert>
            </div>
            <div className={displayNameField}>
                <fieldset>
                    <div className="row">
                        <div className="col-md-12">
                            <Label htmlFor={FirstNameId} className="label-1">Title</Label>
                            <Select id="ckycPersonTitle" aria-labelledby="title-alert" required={true} onChange={onTitleChange}>
                                <SelectOption value="">Select</SelectOption>
                                {titleArray.map(title => (
                                    <SelectOption key={title.value} value={title.value}>{title.name}</SelectOption>

                                ))}
                            </Select>
                        </div>
                        <Alert id="FatherOrMotherTitle-Alert" show={errorData.fatherOrMotherTitleRequired}>Please make a selection.</Alert>
                    </div>
                    <div className="row pad-1-t">
                        <div className="col-md-6">
                            <Label htmlFor={FirstNameId} className="label-1">First name</Label>
                            <Input id="ckycPersonFirstName" name={FirstNameId} maxLength={15} aria-describedby="FatherFirstNameAlert" required={true} onBlur={onFNameBlur} onChange={(e) => setFormData({ ...formData, fatherOrMotherFName: e.target.value })} />
                            <Alert id="FatherOrMotherFLName-Alert" show={errorData.fatherOrMotherFNameRequired}>Please provide the First name.</Alert>
                            <Alert id="NameAlphaNumericFName-Alert" show={errorData.fatherOrMotherFNameAlphaNumeric}>Please ensure First name contains only letters (A-Z, upper and lower case), spaces, hyphens or apostrophes.</Alert>
                        </div>
                        <div className="col-md-6">
                            <Label htmlFor={MiddleNameId} className="label-1">Middle name (Optional)</Label>
                            <Input id="ckycPersonMiddleName" name={MiddleNameId} maxLength={15} onBlur={onMNameBlur} onChange={(e) => setFormData({ ...formData, fatherOrMotherMName: e.target.value })} />
                            <Alert id="NameAlphaNumericMName-Alert" show={errorData.fatherOrMotherMNameAlphaNumeric}>Please ensure Middle name contains only letters (A-Z, upper and lower case), spaces, hyphens or apostrophes.</Alert>
                        </div>
                        <div className="col-md-6">
                            <Label htmlFor={LastNameId} className="label-1">Last name</Label>
                            <Input id="ckycPersonLastName" name={LastNameId} maxLength={15} required={true} onBlur={onLNameBlur} onChange={(e) => setFormData({ ...formData, fatherOrMotherLName: e.target.value })} />
                            <Alert id="FatherOrMotherFLName-Alert" show={errorData.fatherOrMotherLNameRequired}>Please provide the Last name.</Alert>
                            <Alert id="NameAlphaNumericLName-Alert" show={errorData.fatherOrMotherLNameAlphaNumeric}>Please ensure Last name contains only letters (A-Z, upper and lower case), spaces, hyphens or apostrophes.</Alert>
                        </div>
                    </div>
                </fieldset>
                <div className="row pad-1-t">
                    <div className="col-md-6">
                        <Label htmlFor={FirstNameId} className="label-1">Your Central KYC Repository number (optional)</Label>
                        <Input id="ckycRepoNumber" name="CKYC" type="number" maxLength={14} onInput={maxLengthCheck} onBlur={onCkycBlur} />
                    </div>

                </div>
                <Alert id="CkycAlphaNumeric-Alert" show={errorData.ckycAlphaNumericRequired}>Please enter a valid CKYC number.</Alert>
            </div>
        </div>
    );
}
export default Ckyc;